import React, { useState } from "react";
import img from "../assets/Contact/img.png";
import texture from "../assets/Contact/Texture.png";
import "./contact.css";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom"; // Add this at the top

const Contact = () => {
  const navigate = useNavigate(); // Initialize it
  const [loading, setLoading] = useState(false); // State to manage loading state

  const [formData, setFormData] = useState({
    name: "",
    subject: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { name, phone, email, subject, message } = formData;

    if (!name || !phone || !email || !subject || !message) {
      Swal.fire({
        icon: "warning",
        title: "Incomplete Form",
        html: "<b>Please fill in all the fields before submitting.</b>",
      });
      return;
    }
    setLoading(true); // Show loader
    try {
      const response = await fetch(
        "https://hi-labsolution.net/api/radiant-contact.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            name,
            phone,
            email,
            subject,
            message,
          }),
        }
      );

      const result = await response.json();
      console.log("API Response:", result);

      if (response.ok) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          html: "<b>Your message has been sent successfully!</b>",
          
        });

        setFormData({
          name: "",
          subject: "",
          email: "",
          phone: "",
          message: "",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong. Please try again.",
        });
      }
    } catch (error) {
      console.error("Error:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Error occurred while submitting the form.",
      });
    } finally {
      setLoading(false); // Hide loader
    }
  };
  return (
    <>
      <div
        style={{ height: "100vh", width: "100%" }}
        className="container-fluid main p-4 py-5"
      >
        <div
          style={{ height: "100%", width: "100%" }}
          className=" rounded-5 position-relative overflow-hidden"
        >
          {/* First Image */}
          <div className="position-absolute top-0 start-0 w-100 h-100">
            <img
              className="img-fluid w-100 h-100 object-fit-cover"
              src={img}
              alt="Background"
            />
          </div>

          {/* Second Image (Texture) */}
          <div className="position-absolute top-0 start-0 w-100 h-100">
            <img
              className="img-fluid w-100 h-100 object-fit-cover"
              src={texture}
              alt="Texture"
            />
          </div>

          {/* Heading */}
          <div className="position-absolute col-12 top-0 start-0 w-100 h-100 d-flex justify-content-center">
            <h1 className=" contact text-center text-white fw-bold display-3 col-12">
              Contact Us
            </h1>
          </div>

          {/* Form and Address Section */}
          <div
            style={{ width: "100%" }}
            className=" main-form position-absolute py-5 mt-5  p-3"
          >
            <div className="row  p-1">
              {/* Address Section */}
              <div className="col-md-4 col-12 text-white d-flex flex-column mb-4">
                <div>
                  <h5 className="fw-bold fs-3">Address</h5>
                  <p className="fs-5">
                    405, RADHA SWAMI SAMYAK, nr. JK LIGHT, <br /> Patel Chokdi,
                    Lambhvel Rd,
                    <br /> Anand, 388001, Gujarat, India
                  </p>
                  <h5 className="fw-bold fs-3 ">Contact No.</h5>
                  <p className="fs-5  ">
                    <a
                      href="tel:+918154000349"
                      style={{ textDecoration: "none", color: "white" }}
                    >
                      +91 8154000349
                    </a>
                    , <br />
                    <a
                      href="tel:+912692350300"
                      style={{ textDecoration: "none", color: "white" }}
                    >
                      02692 350300
                    </a>
                  </p>
                  <h5 className="fw-bold fs-3">Email</h5>
                  <p className="fs-5">
                    info@radiantsunenergy.com
                    <br />
                    hr@radiantsunenergy.com
                  </p>
                </div>
              </div>

              {/* Form Section */}
              <div className="col-md-8 col-12">
                <div className="bg-dark bg-opacity-50 rounded-4 p-md-4 p-2">
                  <form onSubmit={handleSubmit}>
                    {/* Name Fields */}
                    <div className=" name d-flex gap-2 mb-3">
                      <div className="col-12 col-md-6 mb-3 mb-md-0">
                        <input
                          type="text"
                          className="form-control fw-semibold fs-5"
                          placeholder="Full Name"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="col-12 col-md-6">
                        <input
                          type="text"
                          className="form-control fw-semibold fs-5"
                          placeholder="Phone No."
                          name="phone"
                          value={formData.phone}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    {/* Email and Phone Fields */}
                    <div className="name d-flex gap-2  mb-4">
                      <div className="col-12 col-md-6 mb-3 mb-md-0">
                        <input
                          type="email"
                          className="form-control fw-semibold fs-5"
                          placeholder="Email Address"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="col-12 col-md-6">
                        <input
                          type="text"
                          className="form-control fw-semibold fs-5"
                          placeholder="Subject"
                          name="subject"
                          value={formData.subject}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    {/* Message Field */}
                    <div className="mb-4">
                      <textarea
                        className="form-control fw-semibold fs-4"
                        rows="4"
                        placeholder="Message"
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                      ></textarea>
                    </div>

                    {/* Submit Button */}
                    <div>
                      <button
                        type="submit"
                        className="text-white fw-bold fs-5 border-0 py-2 px-5 rounded-pill"
                        style={{
                          background:
                            "linear-gradient(to right, #FF5E43, #FB992E)",
                          whiteSpace: "nowrap",
                        }}
                        disabled={loading} // Disable button while submitting
                      >
                        {loading && (
                          <div
                            className="spinner-border spinner-border-sm text-light"
                            role="status"
                            style={{ width: "1rem", height: "1rem" }}
                          ></div>
                        )}
                        {loading ? "" : "Submit"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
